import { List } from '@material-tailwind/react';
import React, { useCallback } from 'react';
import ListItemInfo from '../../components/Listas/ListItemInfo';
import { convertToInt } from '../../hook/convertQuantidade';

export const colorApclition = (color) => {
  switch (color) {
    case 'Descontinio':
      return 'bg-gray-500 p-1 rounded-lg text-black text-center ';
    case 'Estoque':
      return 'bg-[linear-gradient(135deg,#28a745,#20c997)] p-1 rounded-lg text-end  text-center ';
    case 'Direta':
      return 'bg-red-500 p-1 rounded-lg  text-center';
  }
};

const ListInfo = ({ produto }) => {
  const textMarcs = useCallback(() => {
    const marcas = produto.marcaDeCompra.map((marca) => marca.nome);
    return marcas ? marcas.join(', ') : '';
  }, [produto]);
  return (
    <List className="sm:grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-full auto-rows-[1fr] text-black dark:text-white ">
      <ListItemInfo title="Winthor" text={produto?.winthor} />
      <ListItemInfo
        title="Quantidade"
        text={produto?.quantidade_total && convertToInt(produto?.quantidade_total)}
      />

      <ListItemInfo title="Endereço" text={produto?.endereco} />
      {produto?.categoriaCompra && (
        <>
          <ListItemInfo title="Marcas" text={produto?.marcaDeCompra ? textMarcs(produto) : ''} />
          <ListItemInfo title="Categoria Compra" text={produto?.categoriaCompra} />
          <ListItemInfo title="Categoria" text={produto?.categoria.nome} />
        </>
      )}
      <div className="absolute sm:static"></div>
      <div className="col-span-2 grid grid-cols-2 gap-2">
        {produto?.ultima_entrada && (
          <ListItemInfo
            title="Ultima entrada"
            text={produto?.ultima_entrada}
            cssContainer="border-green-500"
          />
        )}
        {produto?.ultima_saida && (
          <ListItemInfo
            title="Ultima saida"
            text={produto?.ultima_saida}
            cssContainer="border-red-500"
          />
        )}
      </div>
      <div className="absolute sm:static"></div>
      <ListItemInfo title="Estoque Minimo" text={convertToInt(produto?.estoqueMinimo)} />
      <ListItemInfo title="Compra ideal" text={convertToInt(produto?.estoqueMaximo)} />
    </List>
  );
};

export default ListInfo;
